import createNewProductButton from "../components/newProductButton";
import PrivilegeEnum from "../enums/PrivilegeEnum";
import userView from "../views/userView";
import displayInfoContainer from "../components/infoContainer";
import returnHome from "../helpers/returnHome";
import addUserNameToNavBar from "../helpers/addUserNameToNavBar";
import { getUserByEMail } from "../services/usersService";
export function userViewLogic(store, mainContent) {
    viewRendering(mainContent, store);
    var navBarContainer = loadNavBarContainer();
    logInEvent(store);
    logOutEvent(store, navBarContainer, mainContent);
    privilegeEvents(store, navBarContainer);
}
//view rendering
function viewRendering(mainContent, store) {
    mainContent.innerHTML = userView(store);
}
//load Navigation Bar
function loadNavBarContainer() {
    return document.getElementById("nav-bar-container");
}
// Log in events
function logInEvent(store) {
    var logInForm = document.getElementById("log-in-form");
    if (logInForm) {
        logInForm["submit-button"].addEventListener("click", function () {
            var inputMail = logInForm["mail-adress"].value.trim();
            var logInUser = getUserByEMail(inputMail);
            var inputPassword = logInForm["password"].value.trim();
            verifyUserPassword(logInUser, inputPassword, store);
            renderComponentsAccordingUserPrivileges(store);
        });
    }
}
function verifyUserPassword(logInUser, inputPassword, store) {
    if (logInUser) {
        if (inputPassword === logInUser.password) {
            store.user = logInUser;
            addUserNameToNavBar(store.user.firstName.toUpperCase());
            returnHome();
        }
        else {
            displayInfoContainer("El password ingresado es incorrecto.");
        }
    }
    else {
        displayInfoContainer("El usuario ingresado no existe.");
    }
}
function renderComponentsAccordingUserPrivileges(store) {
    var navBarContainer = document.getElementById("nav-bar-container");
    if (store.user.privilege === PrivilegeEnum.admin) {
        var newProductLink = createNewProductButton();
        navBarContainer.appendChild(newProductLink);
    }
    else {
        var productCreationLink = document.getElementById("product-creation-link");
        if (productCreationLink) {
            navBarContainer.removeChild(productCreationLink);
        }
    }
}
//log out events
function logOutEvent(store, navBarContainer, mainContent) {
    var logOutButton = document.getElementById("log-out");
    if (logOutButton) {
        logOutButton.addEventListener("click", function () {
            store.clearUser();
            viewRendering(mainContent, store);
            addUserNameToNavBar("Inicio");
            removeNewProductLink(navBarContainer);
            returnHome();
        });
    }
}
//privilege events
function privilegeEvents(store, navBarContainer) {
    var privilegeOptions = document.getElementById("privilege");
    if (privilegeOptions) {
        setDefaultOption(privilegeOptions, store);
        privilegeOptions.addEventListener("change", function () {
            setUserPrivilege(privilegeOptions, navBarContainer, store);
            store.saveUser();
        });
    }
}
function setDefaultOption(privilegeOptions, store) {
    if (store.user) {
        if (store.user.privilege == PrivilegeEnum.normal) {
            privilegeOptions.selectedIndex = 0;
        }
        else {
            privilegeOptions.selectedIndex = 1;
        }
    }
}
function setUserPrivilege(privilegeOptions, navBarContainer, store) {
    if (privilegeOptions.value == "ADMIN") {
        var newProductButton = createNewProductButton();
        store.user.privilege = PrivilegeEnum.admin;
        navBarContainer.appendChild(newProductButton);
    }
    else {
        store.user.privilege = PrivilegeEnum.normal;
        removeNewProductLink(navBarContainer);
    }
}
function removeNewProductLink(navBarContainer) {
    var productCreationLink = document.getElementById("product-creation-link");
    if (productCreationLink) {
        navBarContainer.removeChild(productCreationLink);
    }
}
